import http from "../../http-common";
/**
 * Author : AndréK
 * 26/08/2022
*/

//Company
const createCompany = (data) => {
    return http.post("/Company/InsertCompany", data);
};

const getCompany = (data) => {
    return http.post("/Company/FilterCompany", data);
};

const updateCompany = (data) => {
    return http.post("/Company/UpdateCompany", data);
};

//Address
const createCompanyAddress = (data) => {
    return http.post("/Company/InsertCompanyAddress", data);
};

const getCompanyAddress = (data) => {
    return http.post("/Company/FilterCompanyAddress", data);
};

const updateCompanyAddress = (data) => {
    return http.post("/Company/UpdateCompanyAddress", data);
};

//Email
const createCompanyEmail = (data) => {
    return http.post("/Company/InsertCompanyEmail", data);
};

const getCompanyEmail = (data) => {
    return http.post("/Company/FilterCompanyEmail", data);
};

const updateCompanyEmail = (data) => {
    return http.post("/Company/UpdateCompanyEmail", data);
};

//Phone
const createCompanyPhone = (data) => {
    return http.post("/Company/InsertCompanyPhone", data);
};

const getCompanyPhone = (data) => {
    return http.post("/Company/FilterCompanyPhone", data);
};

const updateCompanyPhone = (data) => {
    return http.post("/Company/UpdateCompanyPhone", data);
};


export default {
    createCompany,
    getCompany,
    updateCompany,
    createCompanyAddress,
    getCompanyAddress,
    updateCompanyAddress,
    createCompanyEmail,
    getCompanyEmail,
    updateCompanyEmail,
    createCompanyPhone,
    getCompanyPhone,
    updateCompanyPhone
};
